export default __webpack_public_path__ + "static/media/clear.5a0980d0.svg";